import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "layout-actionbar" }
const _hoisted_2 = {
  key: 0,
  class: "formgroup-inline"
}
const _hoisted_3 = { href: "#" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "layout-breadcrumb layout-breadcrumb-ajust" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "layout-actions" }
const _hoisted_10 = { id: "reportar" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { key: 2 }
const _hoisted_14 = { id: "saving" }
const _hoisted_15 = { key: 3 }
const _hoisted_16 = { class: "user-info" }
const _hoisted_17 = { key: 4 }
const _hoisted_18 = { class: "user-info" }
const _hoisted_19 = { key: 5 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Badge = _resolveComponent("Badge")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Cargando = _resolveComponent("Cargando")!
  const _component_Sugerencias = _resolveComponent("Sugerencias")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      ($setup.getBrokerLogo)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("a", _hoisted_3, [
              _createElementVNode("img", {
                class: "logo",
                style: {"max-height":"30px"},
                src: $setup.getBrokerLogo,
                alt: "Logo del corredor",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ path: '/' })))
              }, null, 8 /* PROPS */, _hoisted_4)
            ]),
            _createElementVNode("div", _hoisted_5, [
              (_ctx.$route.meta.breadcrumb && _ctx.$route.meta.breadcrumb[0])
                ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                    _createTextVNode(_toDisplayString(_ctx.$route.meta.breadcrumb[0].parent) + " ", 1 /* TEXT */),
                    (_ctx.$route.meta.breadcrumb[0].label)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_7, _cache[8] || (_cache[8] = [
                          _createElementVNode("i", {
                            class: "pi pi-fw pi-chevron-right mr-1",
                            style: {"font-size":"0.8rem"}
                          }, null, -1 /* HOISTED */)
                        ])))
                      : _createCommentVNode("v-if", true),
                    _createTextVNode(_toDisplayString(_ctx.$route.meta.breadcrumb[0].label), 1 /* TEXT */)
                  ]))
                : _createCommentVNode("v-if", true)
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_8, _cache[9] || (_cache[9] = [
            _createElementVNode("i", { class: "pi pi-spin pi-spinner" }, null, -1 /* HOISTED */)
          ]))),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("ul", null, [
          _createElementVNode("li", null, [
            _withDirectives((_openBlock(), _createElementBlock("button", {
              id: "portal",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.irAlPortal && $setup.irAlPortal(...args)))
            }, _cache[10] || (_cache[10] = [
              _createElementVNode("i", { class: "pi pi-external-link icon" }, null, -1 /* HOISTED */)
            ]))), [
              [
                _directive_tooltip,
                { value: 'Portal administración' },
                void 0,
                { bottom: true }
              ]
            ])
          ]),
          _createElementVNode("li", null, [
            _withDirectives((_openBlock(), _createElementBlock("button", {
              id: "salesmanager",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.mostrarSalesManager && $setup.mostrarSalesManager(...args)))
            }, _cache[11] || (_cache[11] = [
              _createElementVNode("i", { class: "pi pi-fw pi-sitemap icon" }, null, -1 /* HOISTED */)
            ]))), [
              [
                _directive_tooltip,
                { value: 'Sales Manager' },
                void 0,
                { bottom: true }
              ]
            ])
          ]),
          _createElementVNode("li", null, [
            _withDirectives((_openBlock(), _createElementBlock("button", {
              id: "comment",
              onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.openNewSuggest($event,false)))
            }, _cache[12] || (_cache[12] = [
              _createElementVNode("i", { class: "pi pi-comment icon" }, null, -1 /* HOISTED */)
            ]))), [
              [
                _directive_tooltip,
                { value: 'Reportar sugerencias' },
                void 0,
                { bottom: true }
              ]
            ])
          ]),
          _createElementVNode("li", null, [
            _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_10, [
              _createElementVNode("i", {
                class: "pi pi-exclamation-triangle icon",
                onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.openNewSuggest($event,true)))
              })
            ])), [
              [
                _directive_tooltip,
                { value: 'Reportar incidencia' },
                void 0,
                { bottom: true }
              ]
            ])
          ]),
          ($setup.notificaciones)
            ? (_openBlock(), _createElementBlock("li", _hoisted_11, [
                _withDirectives((_openBlock(), _createElementBlock("button", {
                  id: "notificar",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.goToNotificaciones()))
                }, [
                  _cache[13] || (_cache[13] = _createElementVNode("i", { class: "pi pi-bell icon" }, null, -1 /* HOISTED */)),
                  ($setup.notificaciones.length > 0)
                    ? (_openBlock(), _createBlock(_component_Badge, {
                        key: 0,
                        value: $setup.notificaciones.length,
                        severity: "warning"
                      }, null, 8 /* PROPS */, ["value"]))
                    : _createCommentVNode("v-if", true)
                ])), [
                  [
                    _directive_tooltip,
                    { value: 'Notificaciones' },
                    void 0,
                    { bottom: true }
                  ]
                ])
              ]))
            : _createCommentVNode("v-if", true),
          ($setup.correosConError && $setup.correosConError.length > 0)
            ? (_openBlock(), _createElementBlock("li", _hoisted_12, [
                _withDirectives((_openBlock(), _createElementBlock("button", {
                  id: "correosConError",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.goToNotificaciones('EmailErrors')))
                }, [
                  _cache[14] || (_cache[14] = _createElementVNode("i", { class: "pi pi-envelope icon" }, null, -1 /* HOISTED */)),
                  ($setup.correosConError.length > 0)
                    ? (_openBlock(), _createBlock(_component_Badge, {
                        key: 0,
                        value: $setup.correosConError.length,
                        severity: "danger"
                      }, null, 8 /* PROPS */, ["value"]))
                    : _createCommentVNode("v-if", true)
                ])), [
                  [
                    _directive_tooltip,
                    { value: 'Envío de correos erróneos' },
                    void 0,
                    { bottom: true }
                  ]
                ])
              ]))
            : _createCommentVNode("v-if", true),
          ($setup.saveInProgress)
            ? (_openBlock(), _createElementBlock("li", _hoisted_13, [
                _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_14, _cache[15] || (_cache[15] = [
                  _createElementVNode("i", { class: "color-correduria pi pi-spin pi-save icon" }, null, -1 /* HOISTED */)
                ]))), [
                  [
                    _directive_tooltip,
                    { value: 'Grabando datos' },
                    void 0,
                    { bottom: true }
                  ]
                ])
              ]))
            : _createCommentVNode("v-if", true),
          ($setup.userName)
            ? (_openBlock(), _createElementBlock("li", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_router_link, { to: "/miperfil" }, {
                    default: _withCtx(() => [
                      _cache[16] || (_cache[16] = _createElementVNode("span", { title: "salir" }, null, -1 /* HOISTED */)),
                      _createTextVNode(_toDisplayString($setup.userName), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  })
                ])
              ]))
            : _createCommentVNode("v-if", true),
          ($setup.userName)
            ? (_openBlock(), _createElementBlock("li", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _withDirectives((_openBlock(), _createElementBlock("a", {
                    href: "#",
                    class: "layout-topbar-icon",
                    onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => ($setup.salir && $setup.salir(...args)))
                  }, _cache[17] || (_cache[17] = [
                    _createElementVNode("i", { class: "topbar-icon pi pi-sign-out" }, null, -1 /* HOISTED */)
                  ]))), [
                    [
                      _directive_tooltip,
                      { value: 'Salir' },
                      void 0,
                      { left: true }
                    ]
                  ])
                ])
              ]))
            : (_openBlock(), _createElementBlock("li", _hoisted_19, _cache[18] || (_cache[18] = [
                _createElementVNode("i", { class: "pi pi-spin pi-spinner" }, null, -1 /* HOISTED */)
              ])))
        ])
      ])
    ]),
    _createVNode(_component_Cargando, { ref: "cargando" }, null, 512 /* NEED_PATCH */),
    _createVNode(_component_OverlayPanel, {
      ref: "newsuggest",
      dismissable: true,
      appendTo: "body",
      showCloseIcon: true,
      id: "newsuggest",
      style: {"width":"60vw"},
      breakpoints: { '960px': '75vw' }
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Sugerencias, {
          isError: $setup.isError,
          onDoClose: $setup.closeSuggest
        }, null, 8 /* PROPS */, ["isError", "onDoClose"])
      ]),
      _: 1 /* STABLE */
    }, 512 /* NEED_PATCH */)
  ], 64 /* STABLE_FRAGMENT */))
}